
export const DURATION_FAST = 0.5;
export const DURATION_NORMAL = 1;
export const DURATION_SLOW = 1.5;

export const EASE_TYPE_ONE = "power3.inOut";
export const EASE_TYPE_TWO = "power3.out";
export const EASE_TYPE_THREE = "power3.inOut";